export { Ccontainer } from './Ccontainer';
export type { CcontainerProps } from './Ccontainer';

